export default __webpack_public_path__ + "static/media/image9.230d0c01.jpg";